
import { serializable, alias, primitive } from 'serializr';

export class PaginationConfig {

	@serializable(alias('currentPage', primitive()))
	currentPage?: number = 0;

	@serializable(alias('totalItems', primitive()))
	totalItems?: number = 0;

	@serializable(alias('totalPages', primitive()))
	totalPages?: number = 0;

}